import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';
import { convertDateCustomToDate } from './intl-helpers';
import { CustomDate } from './CustomDate';

const MyFormattedDate = ({ value }) => (value
  ? (
    <FormattedDate
      value={(value instanceof Date) ? value : convertDateCustomToDate(value)}
      year="numeric"
      month="long"
      day="numeric"
    />
  ) : '');

MyFormattedDate.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.instanceOf(CustomDate),
  ]).isRequired,
};

MyFormattedDate.defaultProps = {

};

export default MyFormattedDate;
